




















































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
import { DataSource } from '@/types';
import {
    TableConfig,
    defaultTableConfig,
    columnTemplates
} from '@/core/components/table';
import { CONTRACTS, WindowsServiceContract } from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { Table } from '@/core/components/table/types';

@Component({
    components: {
        DxDataGrid,
        DxColumn
    }
})
export default class PlannedOperationsDetailTable extends Vue {
    @Prop({ type: String, required: true }) public tableKey!: string;
    @Prop({ type: [Array, Object], required: true })
    public dataSource!: DataSource;

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;

    public get defaultTableConfig(): Partial<TableConfig> {
        return defaultTableConfig(this);
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public async mounted() {
        // raise instance of the table up to parent
        this.$emit('setTableInstance', this.tableInstance);
    }

    public get tableInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }
}
